module.exports = __webpack_public_path__ + "static/images/styles/core/components/button/images/default-active-bg-right.eb8ab708.png";


//////////////////
// WEBPACK FOOTER
// ./styles/core/components/button/images/default-active-bg-right.png
// module id = 3482
// module chunks = 11